<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      id='guiruhao20211209'
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="projectSearch" slot-scope="scope">
        <el-select
          v-model="query.project"
          placeholder="项目名称"
          style="width: 100%"
          @change="(value) => projectChange(value)"
        >
          <el-option v-for="item in projectList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </template>
      <template slot="areaIdSearch" slot-scope="scope">
        <el-select
          :value="query.areaId"
          placeholder="区域名称"
          ref="areaIdSelect"
          clearable
          style="width: 100%"
        >
          <el-option :value="query.areaId" show-all-levels :label="query.areaName">
            <el-tree
              node-key="id"
              :data="treeFormAreaData"
              :props="areaTreeProps"
              :load="areaLazyLoadTree"
              lazy
              @node-click="areaNodeTreeClick"
            >
            </el-tree>
          </el-option>
        </el-select>
      </template>
      <template slot="inspectDateRangeSearch" slot-scope="scope">
        <div style="display: flex;">
        <el-date-picker
              style="width:42%;"
              v-model="query.inspectDateFrom"
              type="date"
              value-format="yyyy-MM-dd 00:00:00"
              range-separator="到"
              placeholder="开始日期"
           
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.inspectDateTo"
              type="date"
              value-format="yyyy-MM-dd 23:59:59"
             
              placeholder="结束日期"
            >
            </el-date-picker>
      </div>
        
      </template>
      <template slot="imgAttach" slot-scope="scope">
        <el-button
          type="text"
          size="small"
          v-if="scope.row.imgAttach.length > 0"
          @click="viewImg(scope.row.imgAttach)"
          >查看图片
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/crmedical/project/areainspecttask';
import { mapGetters } from 'vuex';
import { getProjectList } from '@/api/crmedical/project/project';
import { lazyTree } from '@/api/crmedical/project/area';

export default {
  data() {
    return {
      searchFlag: true,
      todoListLength: 10000,
      areaTreeProps: {
        //标题
        label: 'name',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'hasChildren',
        //本节点类型key值
        objectType: 'id',
        //本节点类型名
        objectTypeName: 'name',
      },
      treeFormAreaData: [],
      form: {},
      query: {
        inspectDateFrom:'',
        inspectDateTo:''
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        align:'left',
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        selection: false,
        indexLabel: '序号',
        menu: false,
        searchMenuSpan: 24,
        menuAlign: 'left',
        column: [
          {
            label: '项目名称',
            prop: 'project',
            search: true,
            searchSpan: 6,
            searchslot: true,
            hide: true,
            display: false,
          },
          {
            label: '区域名称',
            prop: 'areaId',
            search: true,
            searchslot: true,
            hide: true,
            display: false,
            searchSpan: 6,
          },

          {
            label: '项目名称',
            prop: 'projectName',
          },
          {
            label: '区域名称',
            prop: 'areaName',
          },
          {
            label: '区域编号',
            prop: 'areaCode',
          },
          {
            label: '区域全称',
            prop: 'areaFullName',
          },
          {
            label: '任务名称',
            prop: 'name',
            hide: true,
          },
          {
            label: '所属科室',
            prop: 'deptName',
          },
          {
            label: '实际巡检时间',
            prop: 'realInspectTime',
          },
          {
            label: '巡检时间',
            prop: 'inspectDateRange',
            searchslot: true,
            search: true,
            display: false,
            hide: true,
          },
          {
            label: '巡检状态',
            prop: 'errorFlag',
            type: 'radio',
            span: 24,
            dicData: [
              {
                label: '异常',
                value: 1,
              },
              {
                label: '正常',
                value: 0,
              },
            ],
            props: {
              label: 'label',
              value: 'value',
            },
          },
          {
            label: '巡检人',
            prop: 'realInspectManName',
            search: true,
            maxlength: 4,
            showWordLimit: true,
            searchSpan: 6,
          },
          {
            label: '任务状态',
            prop: 'taskWorkStatus',
            hide: true,
            display: false,
            type: 'select',
            dicUrl: 'api/blade-system/dict/dictionary?code=task_status',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'string',
          },
          {
            label: '任务开始时间',
            prop: 'startTime',
            hide: true,
          },
          {
            label: '任务结束时间',
            prop: 'endTime',
            hide: true,
          },
          {
            label: '备注',
            prop: 'remark',
          },
          {
            label: '备注图片',
            prop: 'imgAttach',
            width: 80,
            slot: true,
          },
        ],
      },
      data: [],
      inspectDateRangeQuery: [],
    };
  },

  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.areainspecttask_add, false),
        viewBtn: this.vaildData(this.permission.areainspecttask_view, false),
        delBtn: this.vaildData(this.permission.areainspecttask_delete, false),
        editBtn: this.vaildData(this.permission.areainspecttask_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  mounted() {
    this.option.height = this.bodyHeight - 399;
    this.setAvueCrudHeight();
  },
  methods: {
    setAvueCrudHeight() {
      this.$nextTick(() => {
        this.reWrite = true;
        setTimeout(() => {
          this.$refs.crud.$children[1].$children[2].$el.addEventListener('click', () => {
            console.log(this.todoListLength);
            console.log(this.option.height, this.bodyHeight);
            this.searchFlag = !this.searchFlag;
            if (this.todoListLength === 0) {
              if (this.option.height == this.bodyHeight - 399 + 32) {
                this.option.height = this.bodyHeight - 282 + 32;
              } else {
                this.option.height = this.bodyHeight - 399 + 32;
              }
            } else {
              if (this.option.height == this.bodyHeight - 399) {
                this.option.height = this.bodyHeight - 282;
              } else {
                this.option.height = this.bodyHeight - 399;
              }
            }

            this.$refs.crud.getTableHeight();

            onLoad();
          });
        });
      });
    },
    viewImg(attachs) {
      if (attachs.length === 0) {
        this.$message.info('查看失败！');
        return;
      }
      var images = [];
      attachs.forEach((attach) => {
        images.push({ thumbUrl: attach.link, url: attach.link });
      });
      this.$ImagePreview(images, 0);
    },
    areaLazyLoadTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
      } else {
        id = node.data.id;
      }
      if (!this.query.projectId) {
        resolve([]);
        return;
      }
      lazyTree({ parentId: id, projectId: this.query.projectId }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        }
        resolve(data);
      });
    },
    areaNodeTreeClick(node) {
      let nodeId = node.id;
      let nodeTitle = node.name;
      this.query.areaName = nodeTitle;
      this.query.areaId = nodeId;
      setTimeout(() => {
        this.query = Object.assign({}, this.query, { areaName: nodeTitle, areaId: nodeId });
        this.$refs.areaIdSelect.blur();
      });
    },
    projectChange(value) {
      this.query.projectId = value;
      this.query.project = value;
      this.query.areaId = '';
      this.query.areaName = '';
      lazyTree({ parentId: 0, projectId: value }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        }
        this.treeFormAreaData = data;
      });

      this.$forceUpdate();
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query.realInspectManName = '';
      this.query.areaName = '';
      this.query.areaId = '';
      this.query.projectId = '';
      this.query.inspectDateFrom =''
      this.query.inspectDateTo=''
      this.inspectDateRangeQuery = '';
      this.onLoad();
    },
    searchChange(params, done) {
      this.query.realInspectManName = params.realInspectManName;
      this.page.currentPage = 1;
      // if( this.vdui.isEmpty(this.query.inspectDateFrom)||this.vdui.isEmpty(this.query.inspectDateTo)){
      //   console.log("****")
      //   this.query.inspectDateFrom=''
      //   this.query.inspectDateTo=''
      // }
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    getPageData(page) {
      
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          console.log('466  ===================>', data.records.length);
          this.todoListLength = data.records.length;
          if (this.searchFlag) {
            if (data.records.length === 0) {
              this.option.height = this.bodyHeight - 399 + (78 - 46);
              console.log('this.bodyHeight - 339+(78-46)');
            } else {
              this.option.height = this.bodyHeight - 399;
              console.log('this.bodyHeight - 339');
            }
            this.$refs.crud.getTableHeight();
          }
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      if (this.query.projectId) {
        this.getPageData(page);
      } else {
        getProjectList().then((data) => {
          this.projectList = data.data;
          if (this.projectList.length > 0) {
            this.query.projectId = this.projectList[0].id;
            this.query.project = this.projectList[0].name;
            lazyTree({ parentId: 0, projectId: this.query.projectId }).then(({ data }) => {
              if (data instanceof Array) {
                data.forEach((item) => {
                  item.hasChildren = !item.hasChildren;
                });
              }
              this.treeFormAreaData = data;
            });
            this.getPageData(page);
          }
        });
      }
    },
  },
};
</script>

<style>
#guiruhao20211209 .avue-form__menu--center{
  text-align: right;
}
</style>
